import { MdError } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const ErrorComponent = () => {
    const navigate = useNavigate();
    return (
        <div className='d-flex flex-column justify-content-center align-content-center align-items-center h-100 gap-4'>
            <MdError
                size={50}
                className='text-danger'
            />
            <span className='font-weight-bolder'>Oops something went wrong</span>
            <button
                id='continue-button'
                className='btn btn-success'
                onClick={() => navigate(-1)}>
                Continue
            </button>
        </div>
    );
};

export default ErrorComponent;
